const o = `<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M7.5,0h-5A1.5,1.5,0,0,0,1,1.5v8a.5.5,0,0,0,.791.407L4.855,7.718a.249.249,0,0,1,.29,0L8.209,9.907A.5.5,0,0,0,9,9.5v-8A1.5,1.5,0,0,0,7.5,0Z"
        fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
</svg>`;
export {
  o as default
};
